import { post } from "../../utils/Backend";
import { mockListConcepts, mockSearchConceptStocks } from "./ConceptMock";
import type {
  ConceptBrief,
  ConceptSearchParams,
  ConceptStockRow,
} from "./ConceptType";

/** 改为 `mock && false` 可走真实网关 */
const mock = true && false;

const BASE = "/lark/app/concept";

function assertResult<T>(res: T | string): T {
  if (typeof res === "string") {
    throw new Error(res);
  }
  return res;
}

export const ConceptApi = {
  listConcepts: async (spaceProductId: string): Promise<ConceptBrief[]> => {
    const pid = spaceProductId.trim();
    if (!pid) {
      return [];
    }
    if (mock) {
      return mockListConcepts();
    }
    const raw = await post<{ spaceProductId: string }, ConceptBrief[]>(
      `${BASE}/listConcepts`,
      { spaceProductId: pid },
      { silent: true }
    );
    return assertResult(raw);
  },

  searchStocks: async (params: ConceptSearchParams): Promise<ConceptStockRow[]> => {
    if (mock) {
      return mockSearchConceptStocks(params);
    }
    const raw = await post<ConceptSearchParams, ConceptStockRow[]>(
      `${BASE}/searchStocks`,
      params,
      { silent: true }
    );
    return assertResult(raw);
  },
};
